import { saveEventOnAnalytics } from '../../../../utils/helpers'

class ArquivosDigitais {
  static get $inject() {
    return ['$scope', 'gql', 'UsuariosService']
  }

  constructor(scope, gql, UsuariosService) {
    this.scope = scope
    this.gql = gql
    this.UsuariosService = UsuariosService
    this.apply = fun => scope.$apply(fun)
    this.featureFlags = {}
    this.openedNfes = []
    this.openedEfds = []
    this.activeTab = 'inicio'
    this.isFeatureNumeracoesAusentesEnabled = false

    this.mainButtons = [
      {
        id: 'nfe-recebidas',
        icon: 'fa-envelope',
        title: 'NF-e recebidas',
        secondary: 'Aqui você encontrará as NF-e emitidas para sua empresa.'
      },
      {
        id: 'nfe-emitidas',
        icon: 'fa-paper-plane',
        title: 'NF-e/NFC-e emitidas',
        secondary: 'Aqui você poderá armazenar as NF-e/NFC-e que sua empresa emitiu.'
      },
      {
        id: 'cte',
        icon: 'fa-truck',
        title: 'CT-e',
        secondary: 'Aqui você encontrará os CT-e em que sua empresa teve alguma participação.'
      },
      {
        id: 'efd',
        icon: 'fa-file-text',
        title: 'EFD',
        secondary: 'Aqui você poderá armazenar os arquivos EFD da sua empresa.'
      },
      {
        id: 'estatisticas-recebidas',
        icon: 'fa-pie-chart',
        title: 'Estatísticas - NF-e Recebidas',
        secondary: 'Aqui você encontrará estatísticas sobre suas NF-e recebidas.'
      },
      {
        id: 'estatisticas-emitidas',
        icon: 'fa-pie-chart',
        title: 'Estatísticas - NF-e Emitidas',
        secondary: 'Aqui você encontrará estatísticas sobre suas NF-e emitidas.'
      }
    ]

    const url = window.location.pathname;
    const tab = url.split('/arquivos-digitais/')[1];

    this.activeTab = tab == undefined ? 'inicio' : tab;

    scope.$on('filterByEtiqueta', (event, etiqueta) => {
      if (event.targetScope !== scope) {
        scope.$broadcast('filterByEtiqueta', etiqueta)
      }
    })

    scope.$watch(
      () => this.activeTab,
      (tab) => {
        if (tab == undefined || tab == 'inicio') {
          return;
        }

        if (tab.includes('nfe-details')) {
          tab = 'nfe-details';
        }

        saveEventOnAnalytics('ArquivosDigitaisModulosMaisUsados', tab)
      }
    )
  }

  $onInit() {
    const query = gql`
      query CheckFeatureNumeracoesAusentes {
        enabled: checkFeature(feature: "numeracoes_ausentes", empresaId: ${this.contrato.id})
      }
    `

    this.gql.query(query)
      .then(({ enabled }) => this.isFeatureNumeracoesAusentesEnabled = enabled)
      .finally(() => this.apply())

    this.ferramentasPermitidas = Object.fromEntries(
      Object.entries(this.ferramentasDisponiveis).map(([_index, ferramenta]) =>
        [ferramenta, this.ferramentasContratadas.includes(ferramenta)]
      )
    )
  }

  listCtesFor(nfe) {
    this.cteFilter = { chaveNfe: nfe.chave }
    this.activeTab = 'cte'
  }

  openNfeDetails(nfe) {
    this.openedNfes = [...this.openedNfes, nfe].uniqBy(nfe => nfe.id)
    this.activeTab = `nfe-details-${nfe.id}`
  }

  closeNfeDetails(closed) {
    this.openedNfes = this.openedNfes.filter(nfe => nfe.id !== closed.id)
  }

  openEfdAlertas(efd) {
    this.openedEfds = [...this.openedEfds, efd].uniqBy(efd => efd.id)
    this.activeTab = `efd-alertas-${efd.id}`
    saveEventOnAnalytics('AberturaDosAlertasEFD')
  }

  closeEfdAlertas(closed) {
    this.openedEfds = this.openedEfds.filter(efd => efd.id !== closed.id)
  }
}

angular.module("eficienciaFiscalModule").component("arquivosDigitais", {
  controller: ArquivosDigitais,
  bindings: {
    contrato: '<',
    ferramentasDisponiveis: '<',
    ferramentasContratadas: '<'
  },
  template: `
  <div class="row">
    <div class="col-xs-12">
      <ef-tabs active="$ctrl.activeTab">
        <ef-tabs-tab id="inicio">
          <div class="buttons-container">
            <div ng-repeat="button in $ctrl.mainButtons" ng-click="$ctrl.activeTab = button.id"
              data-ferramenta="{{ button.id }}" class="btn btn-primary btn-outlined"
              ng-show="!button.flag || $ctrl.featureFlags[button.flag]">
              <highlighted style="white-space: normal">
                <main>
                  <i class="fa {{ button.icon }}" style="margin-bottom: 10px;"></i> </br>
                  {{ button.title }}
                </main>
                <secondary>{{ button.secondary }}</secondary>
              </highlighted>
            </div>
          </div>
        </ef-tabs-tab>

        <ef-tabs-tab id="nfe-recebidas" label="NF-e recebidas">
          <div>
            <nfe-operations contrato-id="$ctrl.contrato.id" emissao-propria="false"
              on-voltar="$ctrl.activeTab = 'inicio'"
              disabled="!$ctrl.ferramentasPermitidas['arquivos-digitais-nfe-recebidas']">
            </nfe-operations>

            <ef-permissao-ferramenta disabled="!$ctrl.ferramentasPermitidas['arquivos-digitais-nfe-recebidas']">
              <nfe-filter contrato-id="$ctrl.contrato.id" tipo-emissao="TERCEIROS"
                on-change="nfeRecebidasFilter = $newFilter" ferramenta="arquivos-digitais-nfe-recebidas">
              </nfe-filter>
              <nfe-list contrato-id="$ctrl.contrato.id" tipo-emissao="TERCEIROS" filter="nfeRecebidasFilter"
                on-list-ctes="$ctrl.listCtesFor(nfe)" on-open-details="$ctrl.openNfeDetails(nfe)">
              </nfe-list>
            </ef-permissao-ferramenta>
          </div>
        </ef-tabs-tab>

        <ef-tabs-tab id="nfe-emitidas" label="NF-e emitidas">
          <div>
            <nfe-operations contrato-id="$ctrl.contrato.id" emissao-propria="true"
              on-voltar="$ctrl.activeTab = 'inicio'"
              disabled="!$ctrl.ferramentasPermitidas['arquivos-digitais-nfe-emitidas']"
              is-feature-numeracoes-ausentes-enabled="$ctrl.isFeatureNumeracoesAusentesEnabled">
            </nfe-operations>

            <ef-permissao-ferramenta disabled="!$ctrl.ferramentasPermitidas['arquivos-digitais-nfe-emitidas']">
              <nfe-filter contrato-id="$ctrl.contrato.id" tipo-emissao="PROPRIA"
                on-change="nfeEmitidasFilter = $newFilter" ferramenta="arquivos-digitais">
              </nfe-filter>
              <nfe-list contrato-id="$ctrl.contrato.id" tipo-emissao="PROPRIA" filter="nfeEmitidasFilter"
                on-list-ctes="$ctrl.listCtesFor(nfe)">
              </nfe-list>
            </ef-permissao-ferramenta>
          </div>
        </ef-tabs-tab>

        <ef-tabs-tab id="cte" label="CT-e">
          <div>
            <cte-operations contrato-id="$ctrl.contrato.id" on-voltar="$ctrl.activeTab = 'inicio'"
              disabled="!$ctrl.ferramentasPermitidas['arquivos-digitais-cte']">
            </cte-operations>

            <ef-permissao-ferramenta disabled="!$ctrl.ferramentasPermitidas['arquivos-digitais-cte']">
              <cte-filter contrato-id="$ctrl.contrato.id" ng-model="$ctrl.cteFilter"></cte-filter>
              <cte-list contrato-id="$ctrl.contrato.id" filter="$ctrl.cteFilter"></cte-list>
            </ef-permissao-ferramenta>
          </div>
        </ef-tabs-tab>

        <ef-tabs-tab id="efd" label="EFD">
          <div>
            <efd-operations contrato-id="$ctrl.contrato.id" on-voltar="$ctrl.activeTab = 'inicio'"
              disabled="!$ctrl.ferramentasPermitidas['arquivos-digitais-efd']">
            </efd-operations>

            <ef-permissao-ferramenta disabled="!$ctrl.ferramentasPermitidas['arquivos-digitais-efd']">
              <efd-filter contrato-id="$ctrl.contrato.id" on-change="efdFilter = $newFilter"></efd-filter>
              <efd-list contrato-id="$ctrl.contrato.id" filter="efdFilter" on-open-alertas="$ctrl.openEfdAlertas(efd)"></efd-list>
            </ef-permissao-ferramenta>
          </div>
        </ef-tabs-tab>

        <ef-tabs-tab id="estatisticas-recebidas" label="Estatísticas - NF-e Recebidas">
          <operations-toolbar>
            <left>
              <button class="btn btn-default" ng-click="$ctrl.activeTab = 'inicio'">
                <i class="fa fa-arrow-left"></i> Voltar
              </button>
            </left>
          </operations-toolbar>

          <ef-permissao-ferramenta ng-if="$ctrl.activeTab == 'estatisticas-recebidas'"
            disabled="!$ctrl.ferramentasPermitidas['arquivos-digitais-estatisticas-nfe-recebidas']"
            message="Você não possui acesso a uma filial que tenha essa ferramenta contratada.">
            <estatisticas-arquivos contrato-id="$ctrl.contrato.id" tipo-emissao="TERCEIROS"
              ferramenta="arquivos-digitais-estatisticas-nfe-recebidas">
            </estatisticas-arquivos>
          </ef-permissao-ferramenta>
        </ef-tabs-tab>

        <ef-tabs-tab id="estatisticas-emitidas" label="Estatísticas - NF-e Emitidas">
          <operations-toolbar>
            <left>
              <button class="btn btn-default" ng-click="$ctrl.activeTab = 'inicio'">
                <i class="fa fa-arrow-left"></i> Voltar
              </button>
            </left>
          </operations-toolbar>

          <ef-permissao-ferramenta ng-if="$ctrl.activeTab == 'estatisticas-emitidas'"
            disabled="!$ctrl.ferramentasPermitidas['arquivos-digitais-estatisticas-nfe-emitidas']"
            message="Você não possui acesso a uma filial que tenha essa ferramenta contratada.">
            <estatisticas-arquivos contrato-id="$ctrl.contrato.id" tipo-emissao="PROPRIA"
              ferramenta="arquivos-digitais-estatisticas-nfe-emitidas">
            </estatisticas-arquivos>
          </ef-permissao-ferramenta>
        </ef-tabs-tab>

        <ef-tabs-tab ng-repeat="nfe in $ctrl.openedNfes" id="nfe-details-{{ nfe.id }}"
          label="Detalhes NF-e nº {{ nfe.numero }}" on-close="$ctrl.closeNfeDetails(nfe)">
          <div>
            <operations-toolbar>
              <left>
                <button class="btn btn-default" ng-click="$ctrl.activeTab = 'nfe-recebidas'">
                  <i class="fa fa-arrow-left"></i> Voltar
                </button>
              </left>
            </operations-toolbar>

            <nfe-details nfe="nfe.id" contrato-id="$ctrl.contrato.id" empresa-id="nfe.filial.id"></nfe-details>
          </div>
        </ef-tabs-tab>

        <!-- <ef-tabs-tab ng-repeat="efd in $ctrl.openedEfds" id="efd-alertas-{{ efd.id }}"
          label="Alertas do EFD {{ efd.dataReferencia | date: 'MM/yyyy' }}" on-close="$ctrl.closeEfdAlertas(efd)">
          <div>
            <operations-toolbar>
              <left>
                <button class="btn btn-default" ng-click="$ctrl.activeTab = 'efd'">
                  <i class="fa fa-arrow-left"></i> Voltar
                </button>
              </left>
            </operations-toolbar>

            <efd-alertas efd-id="efd.id" filial-id="efd.filial.id"></efd-alertas>
          </div>
        </ef-tabs-tab> -->
      </ef-tabs>
    </div>
  </div>
  `
})
